import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { setAnalyticsConsent } from "@/lib/analytics";

const CLE = "hora_consentement";
const CLE_ANALYTICS = "hora_consentement_analytics";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choixAnalytics = localStorage.getItem(CLE_ANALYTICS);
    if (!choixAnalytics) {
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
    setAnalyticsConsent(choixAnalytics === "accepte");
  }, []);

  const choisir = (accepte) => {
    localStorage.setItem(CLE, accepte ? "accepte" : "essentiels");
    localStorage.setItem(CLE_ANALYTICS, accepte ? "accepte" : "refuse");
    setAnalyticsConsent(accepte);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[70] border-t border-espresso-border bg-espresso/95 text-ivory backdrop-blur-xl"
          data-testid="consent-banner"
          role="dialog"
          aria-label="Message de consentement"
        >
          <div className="mx-auto flex max-w-7xl flex-col items-start gap-5 px-6 py-6 md:flex-row md:items-center md:justify-between lg:px-10">
            <div className="flex items-start gap-4">
              <ShieldCheck size={24} strokeWidth={1.5} className="mt-0.5 shrink-0 text-gold" aria-hidden="true" />
              <p className="max-w-2xl text-sm leading-relaxed text-ivory/75" data-testid="consent-text">
                Nous utilisons des témoins essentiels au fonctionnement du site et, seulement avec
                votre consentement, des témoins d'analyse anonymisés pour comprendre la fréquentation.
                Les renseignements transmis via nos formulaires sont traités conformément à notre{" "}
                <Link to="/politique-confidentialite" className="font-semibold text-gold hover:underline" data-testid="consent-policy-link">
                  politique de confidentialité
                </Link>
                . Votre choix est conservé localement et peut être modifié en effaçant les données du site.
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <button
                onClick={() => choisir(false)}
                data-testid="consent-reject-button"
                className="rounded-sm border border-espresso-border px-6 py-3 text-sm font-semibold text-ivory/75 transition-colors hover:border-gold hover:text-gold"
              >
                Refuser
              </button>
              <button
                onClick={() => choisir(true)}
                data-testid="consent-accept-button"
                className="rounded-sm bg-primary px-8 py-3 text-sm font-semibold text-primary-foreground transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[hsl(22,83%,40%)]"
              >
                J'accepte
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
